<template>
  <b-container v-if="data">
    <b-row class="justify-content-center">
      <b-col md="10" lg="8">
        <h1>Edit Profile</h1>

        <b-card class="mb-3">
          <b-form @submit.prevent="updateUser">
            <h2>User Info</h2>

            <user-info-form
              ref="user_form"
              :passwords="false"
              :data="data"
              :errors="errors"
              :loading="loading"
            />

            <div class="d-flex justify-content-end">
              <b-btn
                type="submit"
                variant="secondary"
                size="lg"
                :disabled="loading"
              >
                <span v-if="!loading">Update User Info</span>
                <b-spinner v-if="loading" small></b-spinner>
              </b-btn>
            </div>
          </b-form>
        </b-card>

        <b-card class="mb-3">
          <b-form @submit.prevent="updatePassword">
            <h2>Password</h2>

            <div class="row mx-md-n2">
              <div class="col-sm-6 px-md-2">
                <b-form-group
                  label="Old Password"
                  :invalid-feedback="
                    errors.old_password ? errors.old_password[0] : ''
                  "
                  :state="errors.old_password ? false : null"
                >
                  <b-form-input
                    name="password"
                    type="password"
                    required
                    trim
                    autocomplete="password"
                    v-model="oldPassword"
                    :state="errors.old_password ? false : null"
                    :disabled="loading"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="row mx-md-n2">
              <div class="col-sm-6 px-md-2">
                <b-form-group
                  label="New Password"
                  :invalid-feedback="
                    errors.new_password ? errors.new_password[0] : ''
                  "
                  :state="errors.new_password ? false : null"
                >
                  <b-form-input
                    name="new-password"
                    type="password"
                    required
                    trim
                    autocomplete="new-password"
                    v-model="newPassword"
                    :state="errors.new_password ? false : null"
                    :disabled="loading"
                  />
                </b-form-group>
              </div>

              <div class="col-sm-6 px-md-2">
                <b-form-group
                  label="Confirm New Password"
                  :state="errors.new_password ? false : null"
                >
                  <b-form-input
                    name="new-password-confimation"
                    type="password"
                    required
                    trim
                    autocomplete="new-password"
                    v-model="newPasswordConfirmation"
                    :state="errors.new_password ? false : null"
                    :disabled="loading"
                  />
                </b-form-group>
              </div>
            </div>

            <div class="d-flex justify-content-end">
              <b-btn
                type="submit"
                variant="secondary"
                size="lg"
                :disabled="loading"
              >
                <span v-if="!loading">Update Password</span>
                <b-spinner v-if="loading" small></b-spinner>
              </b-btn>
            </div>
          </b-form>
        </b-card>

        <b-card class="mb-3">
          <b-form @submit.prevent="updateCompany">
            <h2>Company Info</h2>

            <company-info-form
              ref="company_form"
              :data="data"
              :errors="errors"
              :loading="loading"
            />

            <div class="d-flex justify-content-end">
              <b-btn
                type="submit"
                variant="secondary"
                size="lg"
                :disabled="loading"
              >
                <span v-if="!loading">Update Company Info</span>
                <b-spinner v-if="loading" small></b-spinner>
              </b-btn>
            </div>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import UserInfoForm from '@/components/users/UserInfoForm'
import CompanyInfoForm from '@/components/users/CompanyInfoForm'

export default {
  name: 'ProfileEditProfile',
  components: {
    UserInfoForm,
    CompanyInfoForm,
  },
  data() {
    return {
      data: null,
      errors: {},
      loading: false,
      oldPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
    }
  },
  mounted() {
    this.setupUser()
  },
  methods: {
    setupUser() {
      const data = Object.assign({}, this.$auth.user())

      if (data.expertise && data.expertise.length > 0) {
        data.expertise = data.expertise.map((n) => n.skill_id)
      }

      if (data.company_needs && data.company_needs.length > 0) {
        data.company_needs = data.company_needs.map((n) => n.skill_id)
      }

      this.data = data
    },
    updateUser() {
      this.loading = true
      this.errors = {}

      const form = this.$refs.user_form.user
      const formData = new FormData()
      for (let key in form) {
        if (!form[key]) {
          form[key] = ''
        }

        if (key == 'avatar' && form[key] === this.$auth.user().avatar) {
          continue
        }

        formData.append(key, form[key])
      }

      this.$http
        .post('/profile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then(
          () => {
            this.$auth.fetch()
            this.$bvModal.msgBoxOk('Your profile has been updated.', {
              centered: true,
              title: 'Update User Info',
            })
          },
          (err) => {
            this.errors = err.response.data.errors
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    updatePassword() {
      this.loading = true
      this.errors = {}

      this.$http
        .post('/profile/password', {
          old_password: this.oldPassword,
          new_password: this.newPassword,
          new_password_confirmation: this.newPasswordConfirmation,
        })
        .then(
          () => {
            this.$auth.fetch()
            this.oldPassword = this.newPassword = this.newPasswordConfirmation =
              ''

            this.$bvModal.msgBoxOk('Your password has been updated.', {
              centered: true,
              title: 'Update Password',
            })
          },
          (err) => {
            this.errors = err.response.data.errors
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
    updateCompany() {
      this.loading = true
      this.errors = {}

      this.$http
        .post('/profile/company', this.$refs.company_form.company)
        .then(
          () => {
            this.$auth.fetch()

            this.$bvModal.msgBoxOk('Your company info has been updated.', {
              centered: true,
              title: 'Update Company Info',
            })
          },
          (err) => {
            this.errors = err.response.data.errors
          }
        )
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
